import ControlArea from "components/Layout/control-area";
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { getAllPaymentMethods } from "store/actions";
import Icon from "./assets/payment.svg";
import BootyPagination from "components/shared/pagination";
import { useNavigate, useSearchParams } from "react-router-dom";
import { handleErrMsg } from "helpers/functions";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import TableControl from "components/shared/table";
import { Dropdown } from "react-bootstrap";
import { ReactComponent as MoreIcon } from "./assets/more.svg";
import { ReactComponent as EditIcon } from "./assets/edit.svg";
import { ReactComponent as DeleteIcon } from "./assets/delete.svg";
import { deletePaymentMethod } from "store/actions";
import { getId } from "helpers/functions";

const PaymentMethods = () => {
    const { paymentMethods, loading, error } = useSelector(
        (state) => state.paymentMethods
    );
    const dispatch = useDispatch();
    const { formatMessage, locale } = useIntl();
    const [isDispatched, setIsDispatched] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        setIsDispatched(true);
        dispatch(getAllPaymentMethods(searchParams));
    }, [dispatch, searchParams]);

    // error
    useEffect(() => {
        if (error && isDispatched) {
            toastErrorMessage(
                formatMessage({ id: handleErrMsg(error) }),
                locale
            );
        }
    }, [error, formatMessage, locale, isDispatched]);

    const handleEditTheme = (id) => {
        navigate(`/settings/payment-methods/${id}`);
    };

    const handleDeleteTheme = (id) => {
        dispatch(deletePaymentMethod(id));
    };

    const columns = [
        {
            name: <FormattedMessage id="bankName" />,
            selector: (row) => row?.bankName,
            sortable: true,
        },
        {
            name: <FormattedMessage id="country" />,
            selector: (row) => row?.country?.name?.[locale],
            sortable: true,
        },
        {
            name: <FormattedMessage id="isDefault" />,
            selector: (row) =>
                formatMessage({ id: row?.isDefault ? "yes" : "no" }),
            sortable: true,
        },

        {
            cell: (row) => (
                <>
                    {
                        <div className="global-dropdown">
                            <Dropdown>
                                <Dropdown.Toggle>
                                    <MoreIcon />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {
                                        <Dropdown.Item
                                            onClick={() =>
                                                handleEditTheme(getId(row))
                                            }
                                        >
                                            <EditIcon />
                                            <FormattedMessage id={"edit"} />
                                        </Dropdown.Item>
                                    }

                                    {
                                        <Dropdown.Item
                                            onClick={() =>
                                                handleDeleteTheme(getId(row))
                                            }
                                        >
                                            <DeleteIcon />
                                            <FormattedMessage id={"delete"} />
                                        </Dropdown.Item>
                                    }
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    }
                </>
            ),
            allowOverflow: true,
            button: true,
            width: "56px",
        },
    ];

    return (
        <div className="applications-wrap">
            <ControlArea
                btnTxt={<FormattedMessage id={"addPaymentMethod"} />}
                cardTxt={<FormattedMessage id={"paymentMethods"} />}
                icon={Icon}
                url="/settings/payment-methods/add"
            />
            <TableControl
                title="paymentMethodsTableShow"
                columns={columns}
                data={paymentMethods}
                loading={loading}
            />
            <BootyPagination metaData={paymentMethods?.metadata} />
        </div>
    );
};

export default PaymentMethods;
